export const formatCrewOptionLabel = (user) => {
  const firstName = user?.first_name?.trim() || "";
  const lastName = user?.last_name?.trim() || "";
  const fullName = `${firstName} ${lastName}`.trim();
  const callTimeUsername = user?.call_time_username?.trim() || "";
  return `${fullName} (${callTimeUsername})`;
};
